export const beforeRouteLeaveExtension = {
    beforeRouteLeave: function(to, from, next) {
        if(this && this.$v && this.$v.$anyDirty){
            const answer = window.confirm('Voulez-vous vraiment quitter cette page? Il y a des données non enregistrées!')
            if (answer) { next(); }
            else { next(false) }
        } else { next() }       
    }
  }
